import { useLocalStorage } from 'usehooks-ts';
import { LOCAL_STORAGE_KEYS } from '../consts/localStorage';
import {
  isOnboardingWizardAvailable,
  useDeploymentConfig,
} from '../services/config';

/**
 * Hook that determines if user should be navigated to onboarding wizard
 * based on localStorage flag. Once the user completes or closes the wizard,
 * the flag is set to true and they won't be auto-redirected again.
 */
export const useShouldNavigateToOnboardingWizard = (): {
  shouldNavigateToOnboardingWizard: boolean;
  isLoading: boolean;
} => {
  const config = useDeploymentConfig();
  const [hasCompletedOnboarding] = useLocalStorage(
    LOCAL_STORAGE_KEYS.ONBOARDING_WIZARD_COMPLETED,
    false,
  );
  const isOnboardingAvailable = isOnboardingWizardAvailable(config);

  return {
    shouldNavigateToOnboardingWizard:
      isOnboardingAvailable && !hasCompletedOnboarding,
    isLoading: false,
  };
};
